// extracted by mini-css-extract-plugin
export var addButton = "_5s-d";
export var bullets = "_5s-e";
export var compact = "_5s-2";
export var container = "_5s-j";
export var extendedWarrantyModal = "_5s-f";
export var learn = "_5s-l";
export var learnMore = "_5s-g";
export var offeringOption = "_5s-3";
export var offeringPrice = "_5s-8";
export var offeringSubtitle = "_5s-7";
export var offeringTitle = "_5s-6";
export var offeringsContainer = "_5s-0";
export var pdpTilesBackground = "_5s-n";
export var plan = "_5s-m";
export var regular = "_5s-1";
export var remove = "_5s-k";
export var seeDetailsIcon = "_5s-i";
export var seeDetailsLink = "_5s-h";
export var selectedOption = "_5s-4";
export var shieldIcon = "_5s-b";
export var shieldIconCompact = "_5s-c";
export var subtitle = "_5s-a";
export var title = "_5s-9";
export var unselectedOption = "_5s-5";